// Auth token storage — uses sessionStorage to reduce XSS blast radius
// (tokens don't survive tab close and aren't shared across tabs).
// Non-auth prefs (theme, lang, currency) continue to use localStorage.

const PORTAL_KEY = "sbc_token";
const ADMIN_KEY = "sbc_admin_token";

const store = typeof window !== "undefined" ? window.sessionStorage : null;

export const getToken = () => store?.getItem(PORTAL_KEY) || null;
export const setToken = (t) => store?.setItem(PORTAL_KEY, t);
export const clearToken = () => store?.removeItem(PORTAL_KEY);

export const getAdminToken = () => store?.getItem(ADMIN_KEY) || null;
export const setAdminToken = (t) => store?.setItem(ADMIN_KEY, t);
export const clearAdminToken = () => store?.removeItem(ADMIN_KEY);
